<nav class="navbar navbar-expand-lg navbar-light bg-custom modern-navbar">
  <div class="container-fluid">
    <a class="navbar-brand brand-enhanced" href="#">
      <i class="fas fa-graduation-cap brand-icon"></i>
      <span class="brand-text">{{applicationName}}</span>
    </a> 
    <button class="navbar-toggler custom-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNavDropdown">
      <ul class="navbar-nav ms-auto">
        <li *ngFor="let menu of menuList" class="nav-item dropdown">
            <a *ngIf="!menu.subMenu" class="nav-link menu-link" [routerLink]="menu.link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <span class="link-text">{{menu.name}}</span>
              <span class="link-underline"></span>
            </a>
            <a *ngIf="menu.subMenu" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
              <span class="link-text">{{menu.name}}</span>
              <span class="link-underline"></span>
            </a>
          <div class="dropdown-menu modern-dropdown" aria-labelledby="navbarDropdownMenuLink">
            <a *ngFor="let enu of menu.subMenu" class="dropdown-item modern-dropdown-item" [routerLink]="enu.link">
              <i class="fas fa-angle-right item-icon"></i>
              <span>{{enu.name}}</span>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>